export default function removeUnusedKeys(obj) {
    const newObj = {};
    Object.keys(obj).forEach(key => {
        if (obj[key] || obj[key] === 0) {
            newObj[key] = obj[key];
        }
    });
    return newObj;
}
